/*
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-11-10 15:09:29
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-04-18 17:00:22
 */
const productDetails = {
    key: 'shopDetails',
    type: () => import('./components/tableCell/productCell.vue'),
    fixed: 'left',
    minWidth: '260',
};
export const columns = [
    productDetails,
]